/** Whimsical icons and labels for group threads. */
import { escapeHtml } from './html-utils.js';

export const THREAD_ICON = '🧵';
export const THREAD_ARCHIVED_ICON = '💤';

/**
 * @param {string} name
 * @param {{ archived?: boolean }} [options]
 * @returns {string}
 */
export function formatThreadLabel(name, { archived = false } = {}) {
  const icon = archived ? THREAD_ARCHIVED_ICON : THREAD_ICON;
  return `${icon} ${String(name ?? '')}`;
}

/** Same as formatThreadLabel but escapes name for HTML templates. */
export function formatThreadLabelHtml(name, options = {}) {
  const icon = options.archived ? THREAD_ARCHIVED_ICON : THREAD_ICON;
  return `${icon} ${escapeHtml(name)}`;
}
